module.exports = __webpack_public_path__ + "img/0e2730c.jpg";